import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_4iZ93OTikspu: {
	id: 'prd_4iZ932DEV2OTikspu'
	ident: 'prd_4iZ93OTikspu'
	sku: 'simple_premium_4w_6_79_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: 1
			price_id: 'prc_gthYd2DEV2BPlXP1N'
			amount: 44
			amount_usd: 6.79
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 6.79
			discount: 37.21
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_P38ZS2DEV2HDHWWDn'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_4iZ93OTikspu, SubscriptionProduct>
const prd_4iZ93OTikspu = { ident: 'prd_4iZ93OTikspu' } as typeof _prd_4iZ93OTikspu

export default prd_4iZ93OTikspu
